import {
  OfficeTnCTypeEnum,
  useAcceptAllOfficeConsents,
  useGetOfficeConsent,
} from '~/domain/Consents';
import { useUserSelector } from '~/hooks';
import { IToggleControls } from '~/hooks/useToggle';
import { IUser } from '~/models';
import { firePermPostJobTermsAddendumSubmitted } from '~/posthogs/events';

interface IUseRequireTnCAddendum {
  controls: IToggleControls;
  onSucceedAcceptConsent(): void;
  jobPostingId?: string;
}

export const useRequireTnCAddendum = ({
  controls,
  onSucceedAcceptConsent,
  jobPostingId,
}: IUseRequireTnCAddendum) => {
  const currentUser: IUser = useUserSelector();

  const { data } = useGetOfficeConsent({
    code: OfficeTnCTypeEnum.OFFICE_TNC_PERM,
    officeId: currentUser.id,
  });

  const { mutate, isPending } = useAcceptAllOfficeConsents({
    onError: controls.setOff,
    onSuccess: () => {
      // Track T&C submission event
      if (jobPostingId) {
        firePermPostJobTermsAddendumSubmitted({ postingId: jobPostingId });
      }
      onSucceedAcceptConsent();
    },
  });

  const doAcceptOfficeTnCPerm = () =>
    mutate({
      code: OfficeTnCTypeEnum.OFFICE_TNC_PERM,
      officeId: currentUser.id,
    });

  return {
    isAcceptingConsent: isPending,
    isConsentAccepted: !!data?.isConsented,
    doAcceptOfficeTnCPerm,
  };
};
